function randomInt(minimum: number, maximum: number, inclusive = false) {
  return Math.floor(Math.random() * (maximum - minimum + (inclusive ? 1 : 0))) + minimum;
}

export { randomInt };
